import React from "react";
import { gql } from "@apollo/client";
import RichText from "../../../components-shared/RichText";
import { RichText as RichTextProps } from "../../../../__generated__/graphql";
import { ContentfulComponentType } from "../types";
import TextFieldsV2 from "../TextFieldsV2";
import Gutter from "ui-kit/Gutter";
import { ContentfulC2A } from "../ContentfulC2A";
import { FlexCol } from "ui-kit/Layout/Flex";

export const ContentfulRichText: ContentfulComponentType<RichTextProps> = ({
  title,
  text,
  richText,
  c2A,
}) => {
  return (
    <div className="container">
      <TextFieldsV2
        title={title}
        text={text}
        gutterBottom={richText ? 5 : 0}
        center
      />
      <RichText json={richText?.json} assets={[]} />
      {c2A && (
        <FlexCol alignItems="center" justifyContent="center">
          <Gutter size={4} />
          <ContentfulC2A {...c2A} />
        </FlexCol>
      )}
    </div>
  );
};

ContentfulRichText.fragment = gql`
  fragment RichText on ComponentRichText {
    highlight
    title
    text
    theme
    richText {
      json
    }
    c2A {
      ...C2A
    }
    sys {
      id
      publishedAt
    }
  }
`;
